import { gql } from "@apollo/client"

const GET_SESSION_BOOKING_COUNTS = gql`
  query($id: ID) {
    session(id: $id) {
      id
      no_of_bookings
    }
  }
`

export { GET_SESSION_BOOKING_COUNTS }
